import React, { PureComponent, useCallback } from "react";
import FileSaver from "file-saver";
import { useCurrentPng } from "recharts-to-png";

import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Legend,
} from "recharts";

import "./HedonicSpider.css";

export default function HedonicSpider({ data, metadata, cardSelected }) {
  const [getSpidPng, { ref: spidRef }] = useCurrentPng();
  const handleSpiderDownload = useCallback(async () => {
    const png = await getSpidPng();
    if (png) {
      FileSaver.saveAs(png, "spider.png");
    }
  }, [getSpidPng]);

  const renderLegend = (props) => {
    const { payload } = props;

    return (
      <ul className="legendSpider">
        {payload.map((entry, index) => {
          var color =
            entry.dataKey == "Client_average"
              ? entry.payload.dot.fill
              : entry.payload.fill;

          if (entry.payload.displayLabel == "true") {
            return (
              <li key={`item-${index}`} className="legendSpiderItem">
                <span className="custom__bubble">
                  <span
                    className="custom__bubble--element"
                    style={{
                      backgroundColor: color,
                    }}
                  ></span>
                </span>
                {entry.value}
              </li>
            );
          }
        })}
      </ul>
    );
  };

  return (
    <div className="boxe">
      <button onClick={handleSpiderDownload} className="btn">
        <code>Download</code>
      </button>

      <ResponsiveContainer width="100%" height={450}>
        <RadarChart
          ref={spidRef}
          cx="48%"
          cy={225}
          outerRadius={120}
          width="100%"
          height={450}
          data={data}
          margin={{
            top: 40,
            right: 20,
            bottom: 40,
            left: 20,
          }}
        >
          <PolarGrid />
          <PolarRadiusAxis angle={10} domain={[0, 100]} />
          <PolarAngleAxis dataKey="Attribute" allowDuplicatedCategory={false} />
          <Radar
            name={`Candidat ${cardSelected.Product}`}
            dataKey="Product_point"
            stroke="#FEBE0A"
            fill="#FEBE0A"
            fillOpacity={0.8}
            displayLabel="true"
          />
          <Radar
            name={`Moyenne ${metadata.Client}`}
            dataKey="Client_average"
            displayLabel="true"
            stroke="none"
            fill="none"
            fillOpacity={1}
            strokeWidth={10}
            dot={{ fill: "black", r: 3 }}
          />
          <Radar
            name="Moyenne LLH"
            dataKey="Universe_average"
            stroke="#0D71B7"
            fill="#0D70B7"
            fillOpacity={0.1}
            displayLabel="true"
          />
          <Legend content={renderLegend} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
